import { MESSAGE_TYPE } from '../enums/MessageTypes.js';

function createMessage(content, type, autorIsUser, position) {
    if (type === MESSAGE_TYPE.MESSAGE) {
        return {
            content: {
                items: [
                    {
                        content: { text: content },
                        type: 'text',
                    },
                ],
                type: 'message',
            },
            autorIsUser,
            position,
        };
    }
    if (type === MESSAGE_TYPE.COMPONENT) {
        return {
            autorIsUser,
            position,
            content: {
                items: [{ content, type: 'component' }],
                type: 'component',
            },
        };
    }
    return {
        autorIsUser,
        content,
        position,
    };
}

export { createMessage };
//# sourceMappingURL=createMessage.js.map
